import request from "@/utils/request.js";

// 登录
export function passwordLogin(params) {
  return request({
    url: "auth/passwordLogin",
    method: "post",
    data: params
  });
}

// 获取用户信息
export function userInfo(params) {
  return request({
    url: "user/info",
    method: "get"
  });
}

// 获取分类
export function newsCate(params) {
  return request({
    url: "news/cate",
    method: "get"
  });
}

// 学习记录
export function newsHistory(params) {
  return request({
    url: "news/history", params,
    method: "get"
  })
}

// 直播间列表
export function livesList(params) {
  return request({
    url: "lives/list", params,
    method: "get"
  })
}

// 直播间列表
export function livesInfo(id) {
  return request({
    url: `lives/info/${id}`,
    method: "get"
  })
}

// 课程
export function newsList(params) {
  return request({
    url: `news/list`, params,
    method: "get"
  })
}

// 退出登陆
export function loginout(params) {
  return request({
    url: `auth/loginout`,
    method: "post",
    data: params
  })
}

// 获取系统基础配置
export function getBaseCofig(params) {
  return request({
    url: `getBaseCofig`,
    method: "get"
  })
}

// 课件详情
export function newsInfo(id) {
  return request({
    url: `news/info/${id}`,
    method: "get"
  })
}

// 上传照片
export function upload(params) {
  return request({
    url: `file/upload`,
    method: "post",
    data: params
  })
}


// 新建/修改客户资料
export function editApply(params) {
  return request({
    url: `user/editApply/${params.id}`,
    method: "post",
    data: params
  })
}


// 报备记录列表
export function applyList(params) {
  return request({
    url: `user/applyList`,params,
    method: "get",
  })
}

// 招商详情
export function applyInfo(id) {
  return request({
    url: `user/applyInfo/${id}`,
    method: "get",
  })
}

// 获取余额流水记录
export function balance(params) {
  return request({
    url: `user/balance`,
    method: "get",
  })
}

// 收藏夹列表
export function collectCate(params) {
  return request({
    url: `collect/cate`,params,
    method: "get",
  })
}

// 我的收藏列表
export function collectList(params) {
  return request({
    url: `collect/list`,params,
    method: "get",
  })
}

// 创建/修改收藏夹
export function eidtCate(params) {
  return request({
    url: `collect/eidtCate/${params.id}`,
    method: "post",
    data: params
  })
}

// 添加收藏
export function collectAdd(params) {
  return request({
    url: `collect/add/${params.id}/${params.cate_id}`,
    method: "post",
    data: params
  })
}

// 删除收藏夹
export function collectDelCate(params) {
  return request({
    url: `collect/delCate/${params.id}`,
    method: "post",
    data: params
  })
}

// 删除收藏
export function collectDel(params) {
  return request({
    url: `collect/del/${params.id}/${params.cate_id}`,
    method: "post",
    data: params
  })
}

// 招商记录延期申请
export function userDelay(params) {
  console.log(params)
  return request({
    url: `user/delay/${params.id}`,
    method: "post",
    data: params
  })
}

// 培训列表
export function trainingList(params) {
  return request({
    url: "training/list", params,
    method: "get"
  })
}

// 培训详情
export function trainingInfo(params) {
  return request({
    url: `training/info/${params}`,
    method: "get"
  })
}

// 培训分类
export function trainingCate(params) {
  return request({
    url: `training/cate`,
    method: "get"
  })
}
